/**
 * Metric-callout UI constants and labels, ported from the legacy CTS UI
 * (ADSProjectPortalUI MetricCalloutsConstants).
 */

// The author (`actor`) is no longer a placeholder constant here — it is the
// caller's Midway alias, read from the Mons-injected login meta tag in
// src/accessors/currentUser.ts (FALLBACK_ACTOR covers local dev).

/** Actor the WBR agent publishes AI callouts under (upserts, never overrides humans). */
export const WBR_AGENT_ACTOR = 'WBR Agent';

/**
 * True when a callout/comment author is the WBR agent. Drives the gen-ai
 * display marker (CalloutAuthor) only — never feed this into author identity
 * comparisons (sameActor / isMine).
 */
export function isWbrAgentActor(author: string): boolean {
  return author === WBR_AGENT_ACTOR;
}

export const LABEL_UNKNOWN = 'Unknown';

/**
 * Pagination: the model caps pageSize at 100 (SummaryPageSize @range 1..100).
 * A single cell rarely has more than a page of comments; the page cap keeps a
 * runaway token loop bounded while covering up to 2,000 records.
 */
export const CALLOUTS_PAGE_SIZE = 100;
export const CALLOUTS_MAX_PAGES = 20;

/** Truncate a long callout/comment body until the reader expands it. */
export const CALLOUTS_TRUNCATE_CHARS = 150;

// Placeholders
export const PLACEHOLDER_CALLOUT = 'Write the WBR callout…';
export const PLACEHOLDER_COMMENT = 'Write a comment…';
export const PLACEHOLDER_REPLY = 'Write a reply…';

// Button labels
export const BTN_POST_CALLOUT = 'Post callout';
export const BTN_ADD_COMMENT = 'Comment';
export const BTN_ADD_REPLY = 'Reply';
export const BTN_SAVE = 'Save';
export const BTN_CANCEL = 'Cancel';

// Error messages
export const ERROR_POST_CALLOUT = 'Failed to post callout, please try again.';
export const ERROR_DELETE_CALLOUT =
  'Failed to delete callout, please try again.';
export const ERROR_ADD_COMMENT = 'Failed to add comment, please try again.';
export const ERROR_EDIT_COMMENT = 'Failed to edit comment, please try again.';
export const ERROR_DELETE_COMMENT =
  'Failed to delete comment, please try again.';
export const ERROR_ADD_REPLY = 'Failed to add reply, please try again.';
export const ERROR_EDIT_REPLY = 'Failed to edit reply, please try again.';
export const ERROR_DELETE_REPLY = 'Failed to delete reply, please try again.';
